import { Modal, Tooltip, OverlayTrigger } from "react-bootstrap";
import "../../styles/org-buttons.css";
import "../../styles/Dataset.css";
import React, { useState } from "react";
import Cookies from "js-cookie";
import { VIDEO_EXTS } from "../../constant/FileType";
import { useUploadManager } from "../../utils/UploadContext";
import { buttonText } from "../../utils/buttonText";

const LinkStyle = {
  color: "blue",
  textDecoration: "underline",
  cursor: "pointer",
};

const frameRateTooltip = (
  <div>
    <p>
      <a
        onClick={() => {
          const w = window.open("about:blank");
          w.location.href = `https://en.wikipedia.org/wiki/Frame_rate`;
        }}
        style={LinkStyle}
      >
        <strong>Frame Rate</strong>
      </a>{" "}
      is typically the frequency at which consecutive images are captured or
      displayed.{" "}
    </p>
    <p>
      If the input frame rate is greater than 5, it will take 5 to convert to
      frames.
    </p>
  </div>
);

function UploadModal(props) {
  const { item, loadDatasetList, onHide } = props;
  const { startFileUpload } = useUploadManager();

  const [file, setFile] = useState(null);
  const [fileDragActive, setFileDragActive] = useState(false);
  const [fps, setFps] = useState(null);
  const [imgQuality, setImgQuality] = useState(100);

  const selectUploadFile = (selected) => {
    if (!selected) return;
    setFile(selected);
  };

  const handleFileDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setFileDragActive(false);
    const dropped = e.dataTransfer?.files?.[0];
    selectUploadFile(dropped);
  };

  const handleChangeImgQuality = (e) => {
    let newSplitNum = e.target.value;
    if (newSplitNum < 1 || newSplitNum > 100) {
      if (!newSplitNum) {
        setImgQuality(100);
      }
      return;
    }
    setImgQuality(newSplitNum);
  };

  const isVideoFile = () => {
    if (!file || !file.name) {
      return false;
    }
    const exts = file.name.split(".").pop();
    return VIDEO_EXTS.includes(exts);
  };

  const uploadFile = () => {
    if (!file) {
      window.alert("Please upload a file.");
      return;
    }

    let url;
    if (item.media_type === "audio") {
      url = `/file/upload-audio?folder_name=${item.name}`;
    } else if (item.media_type === "image") {
      url = `/file/upload?folder_name=${item.name}`;
      if (fps) {
        url += `&fps=${fps}`;
      }
      if (imgQuality) {
        if (imgQuality < 1 || imgQuality > 100) {
          window.alert("Image quality should between 1 and 100.");
          return;
        }
        url += `&image_quality=${imgQuality}`;
      }
    } else {
      window.alert("Unsupported media type for upload.");
      return;
    }
    const userToken = Cookies.get("user_token");
    if (userToken) {
      url += `&requesterToken=${encodeURIComponent(userToken)}`;
    }

    startFileUpload({
      url,
      file,
      successMessage: `File '${file.name}' upload success.`,
      onSuccess: () => loadDatasetList?.(),
    });
    onHide();
  };

  return (
    <Modal {...props} size="lg">
      <Modal.Header closeButton closeLabel={buttonText("Close")}>
        <Modal.Title style={{ marginLeft: "10px" }}>Upload Data</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ display: "flex", flexDirection: "column" }}>
        <div
          className={`dataset-file-dropzone${
            fileDragActive ? " is-drag-active" : ""
          }`}
          onDragEnter={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setFileDragActive(true);
          }}
          onDragOver={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setFileDragActive(true);
          }}
          onDragLeave={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setFileDragActive(false);
          }}
          onDrop={handleFileDrop}
        >
          <input
            id="upload-data-file"
            type="file"
            onChange={(e) => selectUploadFile(e.target.files[0])}
          />
          <div className="dataset-file-input">
            <label htmlFor="upload-data-file" className="dataset-file-browse">
              Browse
            </label>
            <span className="dataset-file-name">
              {file ? file.name : "No file chosen"}
            </span>
          </div>
          <p className="dataset-file-drop-hint">
            Drag and drop a file or zip here, or click Browse. You can leave
            this page after starting upload; progress continues in the corner.
          </p>
        </div>
        {file && isVideoFile() && item.media_type === "image" && (
          <div style={{ margin: "1rem", width: "100%" }}>
            <label htmlFor="frame-rate">
              <OverlayTrigger
                overlay={
                  <Tooltip id="tooltip-bottom" placement="bottom">
                    {frameRateTooltip}
                  </Tooltip>
                }
                placement="bottom"
              >
                <a
                  onClick={() => {
                    const w = window.open("about:blank");
                    w.location.href = `https://en.wikipedia.org/wiki/Frame_rate`;
                  }}
                  style={LinkStyle}
                >
                  <strong>Frame Rate</strong>
                </a>
              </OverlayTrigger>
            </label>
            <input
              id="frame-rate"
              type="number"
              value={fps}
              onChange={(e) => setFps(e.target.value)}
            />
            <label htmlFor="image-quality">Image Quality in %</label>
            <input
              id="image-quality"
              type="number"
              value={imgQuality}
              onChange={handleChangeImgQuality}
            />
          </div>
        )}
        <Modal.Footer className="org-modal-footer">
          <button
            type="button"
            className="org-btn org-btn-primary"
            onClick={uploadFile}
          >
            {buttonText("Upload")}
          </button>
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  );
}

export default UploadModal;
